import { useState } from "react";
import { useQueryClient } from "react-query";
import { createPdc } from "services/api/api";

const useCreatePowerDistributionCompany = (controller, onPowerCompanyCreated) => {
  const isDisabled = false;
  const [requestLoading, setRequestLoading] = useState(false);
  const queryClient = useQueryClient();

  const { initializeLoadingToast, updateLoadingToast, clearAllFields } = controller;

  const handleClick = async () => {
    let createToastId;
    try {
      const {
        price,
        powerDistributionCompanyName,
        state,
        hasProcessing,
        hasADifferentPrice,
        engineer,
      } = controller.values();

      setRequestLoading(true);

      createToastId = initializeLoadingToast({
        text: `Criando Concessionária...`,
      });

      const formattedPrice = price == "" ? null : parseInt(price);

      const response = await createPdc(
        powerDistributionCompanyName,
        state.id,
        hasProcessing,
        hasADifferentPrice,
        formattedPrice,
        engineer.id
      );

      if (response.status === 201) {
        const createdPowerCompanyId = response.data?.id;
        
        clearAllFields();
        queryClient.invalidateQueries({ queryKey: ["baseDataQuery"] });

        updateLoadingToast({
          id: createToastId,
          text: `Concessionária Criada com sucesso`,
          type: "success",
        });

        // Chamar callback se fornecido
        if (onPowerCompanyCreated && createdPowerCompanyId) {
          onPowerCompanyCreated(createdPowerCompanyId);
        }
      }
    } catch (error) {
      updateLoadingToast({
        id: createToastId,
        text: error.response?.data?.message ?? "Erro ao criar Concessionária, tente novamente",
        type: "error",
      });
    } finally {
      setRequestLoading(false);
    }
  };

  return {
    isDisabled,
    handleClick,
    requestLoading,
  };
};

export default useCreatePowerDistributionCompany;
